<script setup>
import WizardLayout from '@/Layouts/WizardLayout.vue';
import WizardApplications from '@/components/Dashboard/Wizard/WizardApplications.vue';
import TwoApplications from '@/components/Dashboard/TwoApplications.vue';
import ValidationErrors from '@/components/Shared/ValidationErrors.vue';
import FormButton from '@/components/Shared/Form/Button.vue';
import {onBeforeMount, onMounted, provide, ref, watch} from 'vue';
import {router, useForm, usePage} from '@inertiajs/vue3';
import {isEmpty} from 'lodash';

const page = usePage();

onBeforeMount(() => {
  provide('currentStep', 2);
});

const props = defineProps({
  application1: {
    type: Object,
    default: null,
  },
  application2: {
    type: Object,
    default: null,
  },
  fromAppStore: {
    type: Boolean,
    default: false,
  },
});

const form = useForm({
  first: props.application1?.id,
  second: props.application2?.id,
  isCCVInstall: props.fromAppStore,
});

const applicationToEdit = ref(null);
const selectedApplicationId = ref(null);
const application1 = ref(props.application1);
const application2 = ref(props.application2);

watch(application1, current => {
  updateUrlSearchParams('application1', current?.id);
  form.first = current?.id;
});
watch(application2, current => {
  updateUrlSearchParams('application2', current?.id);
  form.second = current?.id;
});

onMounted(() => {
  if (props.fromAppStore) {
    applicationToEdit.value = application2.value;
  }
});

const updateUrlSearchParams = (name, value) => {
  router.get(
    route(route().current()),
    {
      ...page.props.ziggy.query,
      [name]: value,
    },
    {replace: true},
  );
};

const handleApplicationSelected = application => {
  if (selectedApplicationId.value) {
    if (selectedApplicationId.value === 1) {
      application1.value = application;
    } else if (selectedApplicationId.value === 2) {
      application2.value = application;
    }

    selectedApplicationId.value = null;
  }
};

const handleApplicationSelectedForTwoApps = ({id, application}) => {
  if (id === 1) {
    application1.value = application;
  } else if (id === 2) {
    application2.value = application;
  }
};

const handleRemoveApplication = id => {
  if (id === 1) {
    application1.value = null;
  } else {
    application2.value = null;
  }
};

const submit = () => {
  form.post(route('wizard.step-2.store'));
};

const handleEditApplication = application => {
  applicationToEdit.value = application;
};
</script>

<script>
import DashboardLayout from '@/Layouts/DashboardLayout.vue';

export default {
  layout: DashboardLayout,
};
</script>

<template>
  <wizard-layout>
    <template #default>
      <div>
        <div class="grid-2 wizard_grid">
          <div>
            <h3 class="color_theme mb-2">
              {{ trans('dashboard.integrations.wizard.step_x', {step: 2}) }} - {{ trans('dashboard.integrations.wizard.second_step.title') }}
            </h3>
            <p class="mb-2">{{ trans('dashboard.integrations.wizard.second_step.description') }}</p>

            <validation-errors v-if="!isEmpty(form.errors)" :errors="form.errors"/>

            <two-applications
              :application1="application1"
              :application2="application2"
              @selected-two-apps="form.reset()"
              @edit-application="handleEditApplication"
              @remove-application="handleRemoveApplication"
              @application-selected="handleApplicationSelectedForTwoApps"
              @show="selectedApplicationId = $event"
            />
          </div>
          <div class="wizard_bg wizard_bg_two"></div>
        </div>
        <div v-if="selectedApplicationId || applicationToEdit">
          <wizard-applications
            :is-save-button-enabled="true"
            :app-id="selectedApplicationId"
            :application-to-edit="applicationToEdit"
            :application1="application1"
            :application2="application2"
            @application-selected="handleApplicationSelected"
          />
        </div>
      </div>
    </template>
    <template #actions>
      <div class="grid-2 mt-2 relative z-10">
        <inertia-link class="button button_prev" :href="route('wizard.index')" v-text="trans('pagination.previous')"/>
        <form-button @click="submit" :value="trans('pagination.next')" :processing="form.processing"/>
      </div>
    </template>
  </wizard-layout>
</template>
